module.exports = __webpack_public_path__ + "img/zhong-rain.75c056ca.png";